/* eslint-disable */
import {CognitoAuth, StorageHelper, CognitoIdToken } from 'amazon-cognito-auth-js';
import IndexRouter from '../router/index';
import UserInfoStore from './user-info-store';
import UserInfoApi from './user-info-api';


const CLIENT_ID = '7c6dhbr4evbmfu6m7gjgguaet4';
const APP_DOMAIN = 'serversupport.auth.eu-west-1.amazoncognito.com';
const REDIRECT_URI = '/login/oauth2/code/cognito/';
const USERPOOL_ID = 'eu-west-1_SXjzhKGOq';
const REDIRECT_URI_SIGNOUT = '/logout/';

var authData = {
    ClientId : CLIENT_ID, // Your client id here
    AppWebDomain : APP_DOMAIN,
    TokenScopesArray : ['openid', 'email', 'profile'],
    RedirectUriSignIn : `${window.location.protocol}//${window.location.hostname}${window.location.port != "" ? ":" + window.location.port : ""}${REDIRECT_URI}`,
    RedirectUriSignOut : `${window.location.protocol}//${window.location.hostname}${window.location.port != "" ? ":" + window.location.port : ""}${REDIRECT_URI_SIGNOUT}`,
    UserPoolId : USERPOOL_ID
}

var auth = new CognitoAuth(authData);
auth.userhandler = {
    onSuccess: function(result) {
        console.log("On Success result", result);
        UserInfoStore.setLoggedIn(true);
        UserInfoApi.getUserInfo().then(response => {
            IndexRouter.push('/');
        });
        
        
    },
    onFailure: function(err) {
        UserInfoStore.setLoggedOut();
        IndexRouter.go({ path: '/error', query: { message: 'Login failed due to ' + err } });
    }
};

function getUserInfoStorageKey(){
    var keyPrefix = 'CognitoIdentityServiceProvider.' + auth.getClientId();
    var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
    var userInfoKey = keyPrefix + '.' + tokenUserName + '.userInfo';
    return userInfoKey;
}

var storageHelper = new StorageHelper();
var storage = storageHelper.getStorage();
export default{
    auth: auth,
    login(){
        auth.getSession();
    },
    logout(){
        if (auth.isUserSignedIn()) {
            var userInfoKey = this.getUserInfoStorageKey();
            auth.signOut();

            storage.removeItem(userInfoKey);
        }
    },
    getUserInfoStorageKey,
    getUserGroups() {
        var token = new CognitoIdToken(auth.signInUserSession.getIdToken().getJwtToken());
        var payload = token.decodePayload();
        return payload['cognito:groups'];
    }
}